export const BANNER_LARGE = 'large' as const;
export const BANNER_SMALL = 'small' as const;

export type BannerType = typeof BANNER_LARGE | typeof BANNER_SMALL;
